/**
 * CollabTypeChip
 *
 * "Interne" / "Externe" as a small tag — beside a collab picker once someone is chosen, on the
 * picker's options, and in the tables that list collabs' absences. An externe's leaves and
 * arrêts are handled differently (no CPAM / prévoyance follow-up, see isExterne), so the
 * difference has to be visible wherever one is picked or read.
 */
import { Chip } from "@mui/material";
import { Localize } from "../../app/lang/langs";

/** `fg` is the text and border, `bg` the fill. */
const PALETTE = {
  INTERNE: { fg: "#3949AB", bg: "#E8EAF6" },
  EXTERNE: { fg: "#B45309", bg: "#FFF4E5" },
};

/**
 * Whether a collab (or a row carrying its `type_collab`) is an externe. Anything else counts
 * as interne, as the API does: a missing type is an interne.
 */
export const isExterne = (row) => String(row?.type_collab || "").toLowerCase() === "externe";

/**
 * @param {Object} props
 * @param {Object} props.collab - anything carrying `type_collab` (a collab, a leave, an arrêt)
 * @param {Object} [props.sx]
 */
export default function CollabTypeChip({ collab, sx }) {
  const type = isExterne(collab) ? "EXTERNE" : "INTERNE";
  const palette = PALETTE[type];
  return (
    <Chip
      size="small"
      label={Localize(`WORK_STOPPAGE_${type}`)}
      sx={{
        height: 22,
        fontSize: "0.72rem",
        fontWeight: 600,
        borderRadius: "8px",
        color: palette.fg,
        bgcolor: palette.bg,
        border: `1px solid ${palette.fg}33`,
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}
